export default __webpack_public_path__ + "static/media/breadcrumb-bg-2.5e45f43d.png";